import { h, render } from 'preact'
import { isEmptyObject } from '../modules/utilities.js'
import { SG1Logs } from '../modules/logs.js'

// Components
import { AchatMobile } from '../../components/achat-mobile/achat-mobile.jsx'
import { AlertInfo } from '../../components/alert-info/alert-info.jsx'
import { BandeAccueil } from '../../components/bande-accueil/bande-accueil.jsx'
import { BandeEcommerce } from '../../components/bande-ecommerce/bande-ecommerce.jsx'
import { BandeEquipements } from '../../components/bande-equipements/bande-equipements.jsx'
import { BandeListeContrats } from '../../components/bande-liste-contrats/bande-liste-contrats.jsx'
import { BandeMentionsLegales } from '../../components/bande-mentions-legales/bande-mentions-legales.jsx'
import { BandeOptionsEquipement, bandeOptionsEquipementState } from '../../components/bande-options-equipement/bande-options-equipement.jsx'
import { BandeParcoursMarchand } from '../../components/bande-parcours-marchand/bande-parcours-marchand.jsx'
import { EditoTv } from '../../components/edito-tv/edito-tv.jsx'
import { FilAriane } from '../../components/fil-ariane/fil-ariane.jsx'
import { JeuxVideo } from '../../components/jeux-video/jeux-video.jsx'
import { Jo2024 } from '../../components/jo-2024/jo-2024.jsx'
import { MagTv } from '../../components/mag-tv/mag-tv.jsx'
import { Menu } from '../../components/menu/menu.jsx'
import { MenuOse } from '../../components/menu-ose/menu-ose.jsx'
import { Music, musicState } from '../../components/music/music.jsx'
import { ParcoursNouveauteInternet } from '../../components/parcours-nouveaute-internet/parcours-nouveaute-internet.jsx'
import { ParcoursNouveautePlus } from '../../components/parcours-nouveaute-plus/parcours-nouveaute-plus.jsx'
import { PersoReco } from '../../components/perso-reco/perso-reco.jsx'
import { PrefooterSeo } from '../../components/prefooter-seo/prefooter-seo.jsx'
import { Publicite } from '../../components/publicite/publicite.jsx'
import { BandePushFidelisation } from '../../components/bande-push-fidelisation/bande-push-fidelisation.jsx'
import { ReassuranceBoutique } from '../../components/reassurance-boutique/reassurance-boutique.jsx'
import { ReassuranceEquipement, reassuranceEquipementState } from '../../components/reassurance-equipement/reassurance-equipement.jsx'
import { ReassuranceReseau } from '../../components/reassurance-reseau/reassurance-reseau.jsx'
import { ReassuranceService } from '../../components/reassurance-service/reassurance-service.jsx'
import { RecoEquipements } from '../../components/reco-equipements/reco-equipements.jsx'
import { RecoParcoursProspect } from '../../components/reco-parcours-prospect/reco-parcours-prospect.jsx'
import { ReassuranceTv } from '../../components/reassurance-tv/reassurance-tv.jsx'
import { SeoKeywords } from '../../components/seo-keywords/seo-keywords.jsx'
import { TvLiveReplay, tvLiveReplayState } from '../../components/tv-live-replay/tv-live-replay.jsx'
import { Vod, vodState } from '../../components/vod/vod.jsx'

export const genericOrchestrator = (data) => {
    try {
        let config = {
            achatForfait: { elementId: 'achatForfait', component: AchatMobile, check: ['items'] },
            achatMobile: { elementId: 'achatMobile', component: AchatMobile, check: ['items'] },
            alerteInfo: { elementId: 'alertInfo', component: AlertInfo },
            BandeListesContrats: { elementId: 'listeContrats', component: BandeListeContrats },
            editoTv: { elementId: 'editoTv', component: EditoTv },
            equipments: { elementId: `bandeEquipements_pos${data.id === 'equipments' ? data.zones[0].data.position : ''}`, component: BandeEquipements, check: ['items'] },
            filAriane: { elementId: 'filAriane', component: FilAriane, check: ['items'] },
            jo2024: { elementId: 'jo2024', component: Jo2024 },
            jeuxVideo: { elementId: 'jeuxVideo', component: JeuxVideo, check: ['URL'] },
            legalNotices: { elementId: 'mentionsLegales', component: BandeMentionsLegales, check: ['notes'] },
            magTv: { elementId: 'magTv', component: MagTv, data: { device: window.dataStoreHP.device } },
            menu: { elementId: 'menu', component: Menu, check: ['items'] },
            menuOse: { elementId: 'menuOse', component: MenuOse, data: { pageId: window.dataStoreHP.pageId } },
            music: { state: musicState, elementId: 'music', component: Music },
            offreEtOptions: { state: bandeOptionsEquipementState, elementId: 'bande-options', component: BandeOptionsEquipement },
            parcours: { elementId: 'recoParcoursProspect', component: RecoParcoursProspect, check: ['items'] },
            parcoursMarchand: { elementId: 'bande-parcours-marchand', component: BandeParcoursMarchand, check: ['recommendations'] },
            parcoursMarchandNouveauteInternet: { elementId: 'bande-parcours-nouveaute-internet', component: ParcoursNouveauteInternet, check: ['cards'] },
            parcoursMarchandNouveauteMobileProspect: { elementId: 'parcoursNouveautePlusMobileForfait', component: ParcoursNouveautePlus, check: ['items'] },
            parcoursMarchandNouveauteInternetProspect: { elementId: 'parcoursNouveautePlusInternetFix', component: ParcoursNouveautePlus, check: ['items'] },
            parcoursNouveaute: { elementId: 'parcours4nouveautes', component: BandeParcoursMarchand, check: ['recommendations'] },
            persoReco: { elementId: 'persoReco', component: PersoReco },
            pourquoiChoisirOrange: { elementId: 'reassuranceBoutique', component: ReassuranceBoutique, check: ['items'] },
            prefooter: { elementId: 'prefooterSeoTmp', component: PrefooterSeo },
            pubLienscommerciaux: { elementId: 'pubLienscommerciaux', component: Publicite, data: { type: 'lienscommerciaux' } },
            pubMasthead1: { elementId: 'pubMasthead1', component: Publicite, data: { type: 'masthead1' } },
            pubMasthead2: { elementId: 'pubMasthead2', component: Publicite, data: { type: 'masthead2' } },
            pubNative: { elementId: 'pubNative', component: Publicite, data: { type: 'native' } },
            pubRM: { elementId: 'pubRm', component: Publicite, data: { type: 'rm' } },
            pushFidelisation: { elementId: 'pushFidelisation', component: BandePushFidelisation, check: ['recommendations'] },
            rassuranceEcommerce: { elementId: 'ecommerce', component: BandeEcommerce, check: ['items'] },
            rassuranceReseau: { elementId: 'reassuranceReseau', component: ReassuranceReseau },
            rassuranceService: { elementId: 'rassuranceService', component: ReassuranceService, check: ['items'] },
            rassuranceTv: { elementId: 'reassuranceTv', component: ReassuranceTv },
            recoEquipements: { elementId: `recoEquipements_pos${data.id === 'recoEquipements' ? data.zones[0].data.position : ''}`, component: RecoEquipements, data: { device: window.dataStoreHP.device } },
            reassuranceEquipments: { state: reassuranceEquipementState, elementId: `reassuranceEquipement_pos${data.id === 'reassuranceEquipments' ? data.zones[0].data.position : ''}`, component: ReassuranceEquipement, check: ['items'] },
            seoKeywords: { elementId: 'seoKeywords', component: SeoKeywords },
            tv: { state: tvLiveReplayState, elementId: 'tvLiveReplay', component: TvLiveReplay },
            zonePerso: { elementId: 'zonePerso', component: BandeAccueil, data: { pageId: window.dataStoreHP.pageId, isLogged: window.dataStoreHP.isLogged } },
            vod: { state: vodState, elementId: 'vod', component: Vod, check: ['items'] },
        }
        if (config[data.id] === undefined) throw (`${data.id} n'est pas configuré`)

        if (isEmptyObject(data) || (data.zones[0].data && isEmptyObject(data.zones[0].data))) throw (`${data.id} données manquantes`)


        if (config[data.id].check !== undefined && config[data.id].check.length > 0) {
            for (const key of config[data.id].check) {
                if (data.zones[0].data[key] !== undefined) {
                    const keyData = data.zones[0].data[key]
                    if (Array.isArray(keyData) && data.zones[0].data[key].length === 0) throw (`${config[data.id].elementId}: ${key} vide`)
                    if (typeof keyData === 'object' && !Array.isArray(keyData) && isEmptyObject(data.zones[0].data[key])) throw (`${config[data.id].elementId}: ${key} vide`)
                    if (typeof keyData === 'string' && data.zones[0].data[key] === '') throw (`${config[data.id].elementId}: ${key} vide`)
                } else {
                    throw (`${key} non définie`)
                }
            }
        }

        if (data.id === data.zones[0].id || data.zones[0].id === 'dom') { //if a supprimer quand les makesseinterface auront disparus
            let Component = config[data.id].component
            let extraData = config[data.id].data !== undefined ? config[data.id].data : {}
            let target = document.getElementById(config[data.id].elementId)
            if (target !== null) {
                render(<Component {...data.zones[0].data} eventId={data.id} {...extraData} />, target)
            } else {
                throw (`La section #${config[data.id].elementId} n'existe pas dans la page`)
            }
        } else {
            // Avec Signal
            if (config[data.id].state !== undefined) {
                let value = {}
                value[data.zones[0].id] = data.zones[0].data
                config[data.id].state.value = value
            }
        }
    } catch (error) {
        console.error(`Generic orchestrator de ${data.id} : `, error)
        SG1Logs.incLog('Err_CORCH')
        SG1Logs.sentryEvent({ error: error, data: data, name: 'Generic Orchestrator' })
    }
}
